import VueRouter from "vue-router";

import LoginView from "./views/LoginView";
import DashboardView from "./views/DashboardView";
import PaymentsView from "./views/PaymentsView";
import FrontDeskView from "./views/FrontDeskView";
import TokenView from "./views/TokenView";
import RegisterSuccessView from "./views/RegisterSuccessView";
import QuestionnaireView from "./views/QuestionnaireView";
import ProfileView from "./views/ProfileView";
import SuppliersView from "./views/SuppliersView";
import SupplierDetailView from "./views/SupplierDetailView";
import HowToUseView from "./views/HowToUseView";
import WhereBuyView from "./views/WhereBuyView";
import CheckoutView from "./views/CheckoutView";
import ReferralsView from "./views/ReferralsView";
import RewardsView from "./views/RewardsView";
import RegisterView from "./views/RegisterView";
import ReservedCreditLinesView from "./views/ReservedCreditLinesView";
import ProjectView from "./views/ProjectView.vue";
import CustomerDashboardView from "./views/CustomerDashboardView";
import AccountStatusView from "@/views/AccountStatusView.vue";
import ResourcesView from "@/views/ResourcesView";
import ExcessesView from "@/views/ExcessesView.vue";

//Services
import UserManager from "./services/manager/UserManager";

// Register
import Info from "@/components/register/Info";
import Users from "@/components/register/Users";
import Files from "@/components/register/Files";
import LegalRepresentative from "@/components/register/LegalRepresentative";
import CompanyFiles from "@/components/register/upload/CompanyFiles";
import BankStatmentFiles from "@/components/register/upload/BankStatmentFiles";
import SuccessAlert from "@/components/register/SuccessAlert";
import RegisterCustomerBySupplier from "@/views/RegisterCustomerBySupplier";
import ForgotPassword from "@/views/ForgotPassword";
import ChangePassword from "@/views/ChangePassword";

//Utils
import { refreshSupplierFactoring } from "@/utils/refreshSupplierFactoring";

// 2. Define some routes
// Each route should map to a component.
// We'll talk about nested routes later.
const routes = [
  { path: "/", name: "main", meta: { needAuth: true } },
  {
    path: "/dashboard-customer",
    component: CustomerDashboardView,
    name: "dashboard-customer",
    meta: { needAuth: true, roles: ["admin-customer", "customer"] },
  },
  { path: "/login", component: LoginView, name: "login" },
  {
    path: "/questionnaire/",
    component: QuestionnaireView,
    name: "questionnaire",
    meta: { needQuestionnaireToken: true },
  },
  {
    path: "/register-success/",
    component: RegisterSuccessView,
    name: "register-success",
  },
  {
    path: "/dashboard-supplier",
    component: DashboardView,
    name: "dashboard-supplier",
    meta: { needAuth: true, roles: ["admin-supplier"] },
  },
  {
    path: "/supplier/excesses",
    component: ExcessesView,
    name: "excesses",
    // requireCdc: true — route is only accessible to suppliers with CDC enabled
    meta: { needAuth: true, roles: ["admin-supplier"], requireCdc: true },
  },
  {
    path: "/payments/:status?",
    component: PaymentsView,
    name: "payments",
    meta: {
      needAuth: true,
      roles: [
        "admin-supplier",
        "vendor-supplier",
        "admin-customer",
        "customer",
      ],
    },
  },
  {
    path: "/front-desk/",
    component: FrontDeskView,
    name: "front-desk",
    meta: { needAuth: true, roles: ["admin-supplier", "vendor-supplier"] },
  },
  {
    path: "/token/",
    component: TokenView,
    name: "token",
    meta: { needAuth: true, roles: ["admin-customer", "customer"] },
  },
  {
    path: "/profile/",
    component: ProfileView,
    name: "profile",
    meta: {
      needAuth: true,
      roles: ["admin-supplier", "admin-customer", "customer"],
    },
  },
  {
    path: "/suppliers/",
    component: SuppliersView,
    name: "suppliers",
    meta: { needAuth: true, roles: ["admin-customer", "customer"] },
  },
  {
    path: "/supplier/:id",
    component: SupplierDetailView,
    name: "supplier",
    meta: { needAuth: true, roles: ["admin-customer", "customer"] },
  },
  {
    path: "/how-to-use",
    component: HowToUseView,
    name: "how-to-use",
    meta: { needAuth: true, roles: ["admin-customer", "customer"] },
  },
  {
    path: "/where-buy",
    component: WhereBuyView,
    name: "where-buy",
    meta: { needAuth: true, roles: ["admin-customer", "customer"] },
  },
  {
    path: "/checkout/:payment_code",
    component: CheckoutView,
    name: "checkout",
    meta: { needAuth: true, roles: ["admin-customer", "customer"] },
  },
  {
    path: "/referrals",
    component: ReferralsView,
    name: "referrals",
    meta: { needAuth: true, roles: ["admin-supplier"] },
  },
  {
    path: "/rewards",
    component: RewardsView,
    name: "rewards",
    meta: { needAuth: true, roles: ["admin-customer"] },
  },
  {
    path: "/reserved-credit-lines",
    component: ReservedCreditLinesView,
    name: "reserved-credit-lines",
    meta: { needAuth: true, roles: ["admin-supplier", "vendor-supplier"] },
  },
  {
    path: "/registrar-mis-clientes",
    component: RegisterCustomerBySupplier,
    name: "registrar-mis-clientes",
  },
  { path: "/recursos", component: ResourcesView, name: "resources" },
  // {
  //   path: '/projects',
  //   component: ProjectView,
  //   name: "projects",
  //   children:  [
  //     {
  //       path: '/projects/detail/:id',
  //       name: 'project-detail',
  //       component: () => import('@/components/projects/ProjectDetailView.vue'),
  //       props: true,
  //       meta: { needAuth: true, roles: ["admin-customer", "customer"]}
  //     },
  //     {
  //       path: '/projects/quotes/:id',
  //       name: 'quotes-detail',
  //       component: () => import('@/components/projects/QuotesDetailView.vue'),
  //       props: true,
  //       meta: { needAuth: true, roles: ["admin-customer", "customer"]}
  //     }
  //   ],
  // },
  {
    path: "/projects",
    component: ProjectView,
    name: "projects",
    children: [
      {
        path: "detail/:id",
        name: "project-detail",
        props: true,
      },
      {
        path: "quotes/:id",
        name: "quotes-detail",
        props: true,
      },
    ],
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
    name: "forgot-password",
  },
  {
    path: "/change-password/:token",
    component: ChangePassword,
    name: "change-password",
  },
  {
    path: "/statement/:token?",
    name: "account-status",
    component: AccountStatusView,
    meta: { needAuth: false },
  },
  {
    path: "/register/",
    component: RegisterView,
    name: "register",
    meta: { needRegisterToken: false },
    children: [
      {
        path: "info",
        name: "info",
        component: Info,
      },
      {
        path: "files",
        name: "files",
        component: Files,
        children: [
          {
            path: "company",
            name: "company",
            component: CompanyFiles,
          },
          {
            path: "bank-statements",
            name: "bank-statements",
            component: BankStatmentFiles,
          },
        ],
      },
      {
        path: "legal-representative",
        name: "legal-representative",
        component: LegalRepresentative,
      },
      {
        path: "users",
        name: "users",
        component: Users,
      },
      {
        path: "success",
        name: "success",
        component: SuccessAlert,
      },
    ],
  },
];

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
  mode: "history",
  routes, // short for `routes: routes`
});

router.beforeEach(async (to, from, next) => {
  await refreshSupplierFactoring();

  if (to.matched[0].name == "main") {
    const role = UserManager.getRole();
    switch (role) {
      case "vendor-supplier":
        return next({ name: "front-desk" });
      case "admin-supplier":
        return next({ name: "dashboard-supplier" });
      case "admin-customer":
      case "customer":
        return next({ name: "dashboard-customer" });
      default:
        // Null or unknown role — destroy corrupted session and redirect to login
        UserManager.destroy();
        return next({ name: "login" });
    }
  }

  if (to.meta.needAuth) {
    const token = localStorage.getItem("token");
    if (token) {
      if (to.meta.roles == undefined) {
        return next();
      } else {
        const role = UserManager.getRole();
        if (to.meta.roles.includes(role)) {
          // Additional CDC gate: block routes that require CDC for non-CDC suppliers
          if (to.meta.requireCdc && !UserManager.isCdcEnabled()) {
            return next({ name: "dashboard-supplier" });
          }
          return next();
        } else {
          switch (role) {
            case "vendor-supplier":
              return next({ name: "front-desk" });
            case "admin-supplier":
              return next({ name: "dashboard-supplier" });
            case "admin-customer":
            case "customer":
              return next({ name: "dashboard-customer" });
            default:
              // Null or unknown role — destroy corrupted session and redirect to login
              UserManager.destroy();
              return next({ name: "login" });
          }
        }
      }
    } else {
      if (to.name == "checkout") {
        localStorage.setItem("redirect_to_checkout", true);
      }

      return next({ name: "login" });
    }
  }

  // console.log(to)
  if (to.matched.length > 0) {
    if (to && to.matched[0].name == "register") {
      if (to.query.register_token) {
        localStorage.setItem("register_token", to.query.register_token);
      }

      const token = localStorage.getItem("register_token");

      // if not have token, redirect to step 1
      if (!token) {
        if (to.matched[1].name != "info") {
          localStorage.setItem("currentStep", 1);
          next({ name: "info" });
          return;
        }
      }

      // set status component step
      switch (to.matched[1].name) {
        case "info":
          localStorage.setItem("currentStep", 1);
          break;
        case "files":
          localStorage.setItem("currentStep", 2);
          break;
        case "legal-representative":
        case "users":
          localStorage.setItem("currentStep", 3);
          break;
      }
    }
  }

  next();
});

export default router;
